import React, {Component} from 'react';
import {Row, Col, Form, FormGroup, ControlLabel, ProgressBar, Checkbox, FormControl} from "react-bootstrap";
import moment from 'moment'
import {TopButtonAction} from "../../../../../componentsTopsa/buttons/TopButtons";
import {TopInputDate} from "../../../../../componentsTopsa/inputs/TopInputs";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import TopDostepnosc from "../../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import {TopAlertUwaga} from "../../../../../componentsTopsa/alerty/TopAlerts";
import DateAndTimeFormat from "../../../../../utilities/DateAndTimeFormat";
import Validator from "../../../../../utilities/Validator";
import LSService from "../../../../../utilities/localStorageService/LSService";

const timer = require('react-native-timer');

export default class ObsadaContainerSelect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataOd: moment(),
            dataDo: moment(),
            wybraneTrasy: [],
            kierowca: null,
            error: false,
            stopienZapelnienia: 0,
            czyZapelnienie: false,
            czyOdswiezanie: false,
            czasOdswiezania: 60,
            timerOdswiezania: 60,
            czyPokazywacAnulowaneBisy: false,
            idKu: '',
            czyKliknietoUsunFiltry: false,
        };
        this.onChangeDataOd = this.onChangeDataOd.bind(this)
        this.onChangeDataDo = this.onChangeDataDo.bind(this)
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.onChangeKierowca = this.onChangeKierowca.bind(this)
        this.onClickSzukaj = this.onClickSzukaj.bind(this)
        this.onchangeCzasOdswiezania = this.onchangeCzasOdswiezania.bind(this)
        this.onChangeStopienZapelnienia = this.onChangeStopienZapelnienia.bind(this)
        this.onClickCheckboxZapelnienie = this.onClickCheckboxZapelnienie.bind(this)
        this.onClickOdswiezanie = this.onClickOdswiezanie.bind(this)
        this.timer = this.timer.bind(this)
    }

    componentDidMount() {

        if (Boolean(LSService.pobierzTablicaTrasyObsada())) {

            this.setState({
                wybraneTrasy: LSService.pobierzTablicaTrasyObsada()
            })

          //  setTimeout(function () {
          //      this.onClickSzukaj(true)
           // }.bind(this),1000)

        }

    }

    onChangeDataOd(e) {
        this.props.handleUkryjObsady()
        this.setState({dataOd: e})
    }

    onChangeDataDo(e) {
        this.props.handleUkryjObsady()
        this.setState({dataDo: e})
    }

    onChangeTrasa(e) {
        this.props.handleUkryjObsady()
        this.setState({wybraneTrasy: e})
    }

    onChangeKierowca(e) {
        this.setState({kierowca: e})
    }

    onchangeCzasOdswiezania(e) {
        this.setState({czasOdswiezania: e.target.value, timerOdswiezania: e.target.value})
        timer.clearInterval('zliczanieOdswiezenia')

        if (e !== null && this.state.czyOdswiezanie) {
            if (e.target.value !== '')
                this.setInterval(e.target.value)
        }
        if (!Validator.validateInt(e.target.value)) alert('Czas odswieżania musi być liczbą całkowitą dodatnią!')
    }

    onClickSzukaj() {

        if (this.state.wybraneTrasy.length > 0) {
            //ustawienie do localStorage
            LSService.ustawTablicaTrasyObsada(this.state.wybraneTrasy)
        }

        this.setState({error: false, czyOdswiezanie: false})
        timer.clearInterval('zliczanieOdswiezenia')
        if (Boolean(this.state.dataDo) && Boolean(this.state.dataOd)) {
            if (DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd) <= DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo)) {

                if (this.state.stopienZapelnienia >= 0 && this.state.stopienZapelnienia <= 150) {

                    this.props.handleClickSzukaj(DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd), DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo), this.state.wybraneTrasy, this.state.kierowca, this.state.idKu, this.state.stopienZapelnienia, this.state.czyPokazywacAnulowaneBisy)

                }
                else {
                    this.setState({error: 'Niepoprawny stopień zapełnienia - powinna być to liczba całkowita w zakresie 0 - 100'})
                }

                /*if(this.state.czesciowoZapelnione) rodzajZapelnienia = 1
                if(this.state.tylkoZapelnione) rodzajZapelnienia = 2*/

            }
            else {
                this.setState({error: 'Data od nie może być większa od daty do'})
            }
        }
        else {
            this.setState({error: 'Zakres dat jest obowiązkowy'})
        }
    }

    formatTrasaSelect(option, simplify) {
        if (simplify) {
            return option.nazTr;
        } else {

            return <div><span className={'label label-ebus-primary'}>{option.kodTrasy}</span> {option.nazTr} <TopDostepnosc wartoscWarunek={0}
                                                                                                                            wartosc={option.status}
                                                                                                                            czyMarginesLewy={true}/>
            </div>
        }
    }

    onChangeStopienZapelnienia(e) {
        if (e.target.value !== '') {
            this.setState({
                stopienZapelnienia: e.target.value
            })
            if (e.target.value >= 0 && e.target.value <= 150) {
                this.props.handleChangeZapelnienie(e.target.value)
            }
            else {
                alert('Stopien zapełnienia musi być liczbą całkowitą z zakresu 0 - 100')
            }
        } else {
            this.setState({
                stopienZapelnienia: 0
            })
            this.props.handleChangeZapelnienie(0)
        }
    }

    timer() {
        this.setState({
            timerOdswiezania: this.state.timerOdswiezania - 1
        })
        if (this.state.timerOdswiezania < 1) {
            this.setState({timerOdswiezania: this.state.czasOdswiezania})
            this.props.handleOdswiezObsade(this.state.stopienZapelnienia, 'odswiezenieTimer')
        }

    }

    onClickOdswiezanie() {
        this.setState({czyOdswiezanie: !this.state.czyOdswiezanie})
        timer.clearInterval('zliczanieOdswiezenia')
        if (this.state.czyOdswiezanie === true) {
        }
        else {
            this.setInterval()
        }
    }

    onClickCheckboxZapelnienie() {
        if (this.state.czyZapelnienie === true) {
            this.setState({czyZapelnienie: false})
        }
        else {
            this.setState({czyZapelnienie: true})
        }
    }

    setInterval() {
        timer.setInterval('zliczanieOdswiezenia', this.timer.bind(this), 1000);
    }

    render() {

        return (
            <div>
                <Form>
                    <FormGroup>
                        <Col xs={12} lg={2}>
                            <ControlLabel>
                                Data od <span style={{color: 'red'}}>*</span>
                            </ControlLabel>
                            <TopInputDate onChange={this.onChangeDataOd} value={this.state.dataOd} disabled={this.state.idKu.length > 0}/>
                        </Col>
                        <Col xs={12} lg={2}>
                            <ControlLabel>
                                Data do <span style={{color: 'red'}}>*</span>
                            </ControlLabel>
                            <TopInputDate onChange={this.onChangeDataDo} value={this.state.dataDo} disabled={this.state.idKu.length > 0}/>
                        </Col>
                        <Col xs={12} lg={5}>
                            <Col xs={12} lg={6}>
                                <ControlLabel>
                                    Szukaj po trasie
                                    {
                                        Boolean(LSService.pobierzTablicaTrasyObsada()) ?
                                            (LSService.pobierzTablicaTrasyObsada().length > 0 && !this.state.czyKliknietoUsunFiltry) ?
                                                <span
                                                    onClick={() => {
                                                        LSService.usunTablicaTrasyObsada();
                                                        this.setState({czyKliknietoUsunFiltry: true})
                                                    }}
                                                    style={{marginLeft: "3px", color: "grey", cursor: "pointer", fontSize: "10px"}}>
                                                     <i className={"fa fa-times"}></i> usuń zapisany filtr tras
                                                </span>
                                                : "" : ""
                                    }
                                </ControlLabel>
                                <TopSelect onChange={this.onChangeTrasa}
                                           value={this.state.wybraneTrasy}
                                           options={this.props.trasy}
                                           valueKey={'idTr'}
                                           labelKey={'nazTr'}
                                           valueRenderer={(o) => this.formatTrasaSelect(o, true)}
                                           optionRenderer={(o) => this.formatTrasaSelect(o, false)}
                                           disabled={this.state.idKu.length > 0}
                                           multi
                                />
                            </Col>
                            <Col xs={12} lg={6}>
                                <ControlLabel>
                                    Szukaj po kierowcy
                                </ControlLabel>
                                <TopSelect onChange={this.onChangeKierowca} value={this.state.kierowca} options={this.props.kierowcy}
                                           valueKey={'idKi'} labelKey={'informacje'}
                                           disabled={this.state.idKu.length > 0}
                                />
                            </Col>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Row>
                                <Col xs={12} lg={8}>
                                    <span style={{width: "20%", display: "inline-block"}}>lub</span>
                                    <div style={{width: "80%", display: "inline-block"}}>
                                        <ControlLabel>
                                            Szukaj po kursie
                                        </ControlLabel>
                                        <FormControl onChange={(e) => this.setState({idKu: e.target.value})} type={"number"}/>
                                    </div>
                                </Col>
                                <Col xs={12} lg={4}>
                                    <div className={'add-label-margin'}></div>
                                    <TopButtonAction text={'Szukaj'} iconType={'fa fa-search'} btnSize={'medium'} onClick={this.onClickSzukaj}/>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={12}>
                            <Checkbox onChange={() => this.setState({czyPokazywacAnulowaneBisy: !this.state.czyPokazywacAnulowaneBisy})}
                                      checked={this.state.czyPokazywacAnulowaneBisy}>Pokaż anulowane bisy</Checkbox>
                        </Col>
                    </FormGroup>
                    <FormGroup id={'SearchboxObsadyDodstkoweOpcje'}>
                        <Col xs={12} lg={6}>
                            <div className={'add-label-margin'}></div>

                            <ControlLabel>Pokazuj kursy zapełnione od minimum</ControlLabel>
                            <input type={'number'} min={0} max={150} className={'form-control'} defaultValue={0}
                                   onChange={this.onChangeStopienZapelnienia}
                                   style={{display: 'inline', width: '70px', margin: '0 3px'}}/>
                            <ControlLabel>%</ControlLabel>

                            <ControlLabel style={{marginLeft: '25px'}}>Odświeżaj co</ControlLabel>
                            <input defaultValue={'60'} type={'number'}
                                   min={1} max={999999} className={'form-control'} onChange={this.onchangeCzasOdswiezania}
                                   style={{display: 'inline', width: '80px', margin: '0 3px'}}/>
                            <ControlLabel style={{marginRight: '25px'}}>sekund</ControlLabel>

                            {
                                Boolean(this.state.czyOdswiezanie) ?
                                    <TopButtonAction btnSize={'md'} btnColor={'warning'} iconType={'fa fa-power-off'} text={'Dezaktywuj'}
                                                     onClick={this.onClickOdswiezanie}/>
                                    :
                                    <TopButtonAction btnSize={'md'} btnColor={'warning'} iconType={'fa fa-refresh'} text={'Zastosuj'}
                                                     onClick={this.onClickOdswiezanie}/>

                            }
                        </Col>
                        <Col xs={12} lg={5}>
                            {
                                Boolean(this.props.czyUstawionoPelenWidokKalendarza) ?
                                    <div className={'przyciskiOdswiezaniaNaKalendarzuPelnyEkran'}>
                                        {
                                            Boolean(this.state.czyOdswiezanie) ?
                                                <span onClick={this.onClickOdswiezanie} className={'odswiezanie wylacz'}><i
                                                    className={'fa fa-power-off'}></i> wyłącz odświeżanie</span>
                                                :
                                                <span onClick={this.onClickOdswiezanie} className={'odswiezanie wlacz'}><i
                                                    className={'fa fa-power-off'}></i> włącz odświeżanie</span>
                                        }
                                    </div>
                                    :
                                    ''
                            }
                            <TopIf isTrue={this.state.czyOdswiezanie}>
                                <div style={{marginTop: '30px'}}
                                     className={this.props.czyUstawionoPelenWidokKalendarza ? 'pokazProgressNadKalendarzemNaPelenEkran' : ''}>
                                    <ProgressBar style={{marginBottom: '2px'}}>
                                        <ProgressBar bsStyle="warning" now={(this.state.timerOdswiezania * 100) / this.state.czasOdswiezania}
                                                     key={1}/>
                                    </ProgressBar>
                                    <div style={{textAlign: 'center', color: 'grey', fontStyle: 'italic', fontSize: '12px'}}>
                                        Odświeżenie nastąpi za {this.state.timerOdswiezania} sekund
                                    </div>
                                </div>
                            </TopIf>
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col xs={12} lg={8}>
                            <TopIf isTrue={this.state.error}>
                                <TopAlertUwaga text={this.state.error}/>
                            </TopIf>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/obsada/components/ObsadaContainerSelect.js